import { useMemo } from "react";

import routes from "@/features/shared/navigation/navigation.routes";

import { StyledWrapper, StyledItem, StyledLink } from "./styled";

interface NavigationToggleItemProps {
  item: NavigationToggleItem;
}

interface NavigationToggleItem {
  name: string;
  href: string;
}

const NavigationToggleItem = ({ item }: NavigationToggleItemProps) => {
  return (
    <StyledLink to={item.href} end>
      {({ isActive }) => (
        <StyledItem className={isActive ? "active" : undefined}>{item.name}</StyledItem>
      )}
    </StyledLink>
  );
};

const NavigationToggle = () => {
  const navItems = useMemo(
    () => [
      {
        name: "Dashboards",
        href: routes.admin.home,
      },
      {
        name: "Organisaties",
        href: routes.admin.organisations,
      },
      {
        name: "Extranetten",
        href: routes.admin.extranets,
      },
    ],
    [],
  );

  return (
    <StyledWrapper>
      {navItems.map((item) => (
        <NavigationToggleItem item={item} key={item.href} />
      ))}
    </StyledWrapper>
  );
};

export default NavigationToggle;
